import React, { useState, useEffect } from "react";

// Semantic UI React
import { Checkbox, List } from "semantic-ui-react";

// Import Esri Components
import TileLayer from "@arcgis/core/layers/TileLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";

const StaticLayerWidget = ({
  view,
  static_layers,
  localConfig,
  setLocalConfig,
}) => {
  const [layers, setLayers] = useState(null);
  const [config, setConfig] = useState(localConfig.static_layers || []);

  useEffect(() => {
    setLayers(
      static_layers.filter((layer) => layer.name != "Surrounding Counties")
    );

    // Add the Surrounding Counties layer
    view.map.layers.add(
      new TileLayer({
        url: static_layers.filter(
          (layer) => layer.name === "Surrounding Counties"
        )[0].url,
        id: "Surrounding Counties",
        title: "Surrounding Counties",
        visible: true,
        minScale: 409600,
        maxScale: 200,
        minZoom: 0,
        maxZoom: 14,
        index: 1,
        print: true,
        legendEnabled: false,
        static: true
      })
    );
  }, []);

  useEffect(() => {
    if (layers) {
      layers
        .filter((layer) => config.includes(layer.id))
        .forEach((layer) => handleChange(layer));
    }
  }, [layers]);

  // update the configs when they change
  useEffect(() => {
    if (config) {
      // Update the localConfig

      var obj = { ...localConfig };
      obj.static_layers = config;

      setLocalConfig(obj);
    }
  }, [config]);

  const handleChange = (layer) => {
    // Find any matching layer ids
    let match = view.map.findLayerById(
      layer.name.replace(/\s+/g, "-").toLowerCase()
    );

    // Create new instance of the config
    let new_config = [...config];

    if (match) {
      // Remove the layer from the map
      view.map.layers.remove(match);

      // If there is a key then parse the static layer array
      const index = new_config.indexOf(layer.id);
      if (index > -1) {
        new_config.splice(index, 1);
      }

      // push to localforage and config
      setConfig(new_config);
    } else {
      const args = {
        url: layer.url,
        id: layer.name.replace(/\s+/g, "-").toLowerCase(),
        title: layer.name,
        index: 1,
        minScale: 409600,
        maxScale: 200,
        print: true,
        legendEnabled: false,
        static: true
      };

      const obj = layer.tiled ? new TileLayer(args) : new MapImageLayer(args);

      view.map.layers.add(obj);

      // Add the layer id to the array if it doesn't exist
      new_config.indexOf(layer.id) === -1 && new_config.push(layer.id);

      // Sort the array
      new_config = new_config.sort();

      // Update the config
      setConfig(new_config);
    }
  };

  if (!config || !layers) {
    return null;
  }

  return (
    <List style={{ padding: "0 .5em" }}>
      {layers
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .map((layer) => {
          return (
            <List.Item key={layer.id} style={{ paddingBottom: ".5em" }}>
              <Checkbox
                style={{ width: "100%" }}
                checked={config.includes(layer.id)}
                label={layer.name}
                onClick={() => handleChange(layer)}
              />
            </List.Item>
          );
        })}
    </List>
  );
};

export default StaticLayerWidget;
